import React from 'react';
import {
  Paper, Typography, Stack, Divider, Box, Tooltip,
} from '@mui/material';
import { useDrag } from 'react-dnd';
import { ISubscriptions } from '@llws/lift-entity-interfaces';

interface SubscriptionCardProps {
  subscription: ISubscriptions;
  draggable?: boolean;
  selected?: boolean;
  onClick?: () => void;
}

export const SubscriptionCard: React.FC<SubscriptionCardProps> = ({
  subscription, draggable = true, selected = false, onClick,
}) => {
  const [{ isDragging }, dragRef] = useDrag(() => ({
    type: 'SUBSCRIPTION',
    item: { subscriptionId: subscription.id },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }), [subscription]);

  const trimmedDescription =
    subscription.invoiceDescription || 'Untitled Subscription';

  return (
    <Tooltip
      title={
        <div>
          <div><strong>Subscription ID:</strong> {subscription.id}</div>
          <div><strong>Invoice Description:</strong> {subscription.invoiceDescription}</div>
          <div><strong>Start Date:</strong> {subscription.startDate ?? "-"}</div>
          <div><strong>Expiry Date:</strong> {subscription.expiryDate ?? "-"}</div>
        </ div>
      }
      arrow
    >
      <Paper
        ref={draggable ? dragRef : null}
        elevation={2}
        sx={{
          p: 1,
          borderRadius: 1.5,
          opacity: isDragging ? 0.5 : 1,
          cursor: draggable ? 'grab' : 'default',
          border: selected ? '2px solid #2196f3' : '1px solid #ccc',
          bgcolor: selected ? '#e3f2fd' : '#fff',
          transition: 'opacity 0.2s ease-in-out',
          mr: 1,
          mb: 1,
        }}
        onClick={onClick}
      >
        <Box>
          <Typography
            variant="body2"
            fontWeight="medium"
          >
            {trimmedDescription}
          </Typography>
        </Box>
      </Paper>
    </Tooltip>
  );
};
